{
  "00c6dcd85ab3df6e": "Error al enviar la solicitud. Por favor, inténtalo de nuevo.",
  "04ab54130564549c": "Nuestro equipo de operaciones revisará tu solicitud y se pondrá en contacto contigo pronto.",
  "05486965a07f6572": "Por favor, proporciona detalles adicionales",
  "155f816c0407310c": "Enviar",
  "19766ed6ccb2f4a3": "Cancelar",
  "1ca1a8abbdf0992d": "Solo el lugar de trabajo puede hacer actualizaciones",
  "1d958732b88a662e": "Detalles del documento",
  "1f9da3aec076bf42": "Desplazar tipos de profesionales hacia la izquierda",
  "28e313dc7a8695ee": "¿Qué cambios deseas hacer?",
  "306f1bb20677a622": "Número de teléfono",
  "31e392d1c0378bec": "Aplicar",
  "36094873f44f5122": "Por favor, introduce un número de teléfono válido de EE. UU.",
  "38dcdfef0e61dc47": "Información adicional",
  "398521f2d7a62128": "Tipo(s) Profesional(es)",
  "546ebb8eb993ea56": "Filtros",
  "604fd1b2e29c688a": "Se requiere nombre",
  "6b02e0d363a4af1c": "Añadido",
  "6d7fce11ae006a0d": "Correo electrónico de contacto",
  "6fddc235cee48e78": "Buscar un documento",
  "711482aaefbfae1f": "Realiza actualizaciones en este documento",
  "7391d98650ee8931": "No se encontró ningún documento.",
  "7b25a882e9bc3515": "Cerrar visor",
  "8158c43ffa300840": "Requerido para",
  "896607755f418e25": "Desplazar tipos de profesionales hacia la derecha",
  "8b8840b5dc4573bf": "¿A quién debemos contactar para discutir los cambios que desea realizar en este documento?",
  "8cc4f0417f69ea68": "Introduce el nombre completo",
  "904b4af203bd9342": "Requisitos del lugar de trabajo",
  "923b95b59c0fb208": "Todos los profesionales",
  "92eee4a4930f5e8e": "Número de teléfono de contacto",
  "969ccbd3cf6300ec": "Correo electrónico",
  "997605105c518f21": "Tipo Profesional:",
  "a2c9cfae50b8de5b": "No se pueden cargar los documentos requeridos",
  "aae9291101244de9": "Se requiere correo electrónico",
  "b00f7e3ae5e87365": "Por favor, introduce una dirección de correo electrónico válida",
  "b5b8cb11a02602cf": "Ver documento",
  "baaa3007f92b4afd": "Abrir filtros",
  "bc4ff1d271199403": "Los profesionales suben su documento para cumplir con este requisito. No hay una plantilla estándar.",
  "bebb152dbd4eb6ff": "Se requiere número de teléfono",
  "c011d6097bfbc8e9": "Licencia",
  "c1c1009d3f37ec05": "Actualizar",
  "c9fe2289b6dfbc06": "Actualizar requisito",
  "cee3bce87ee11bce": "Menos requisitos a menudo significa mejor cobertura. Si ya no necesita un requisito, haga clic",
  "d06001d656b14482": "Tipo Profesional",
  "d6eafe8235910042": "Descargar",
  "d96d347df6729e47": "y podemos ayudarle a eliminarlo.",
  "daee7606b339f3c3": "Restablecer",
  "dcc839a4015c4b7d": "Ver",
  "dcd1d5223f73b3a9": "Nombre",
  "ddec0fc313b40614": "Nombre de contacto",
  "df0fe79898ef413e": "Imprimir",
  "e01f7ad88a2c280e": "Todos los Tipos Profesionales"
}
